export default __webpack_public_path__ + "static/media/triangles-programas.536dbee9.png";